import { render, staticRenderFns } from "./ApplicationPermission.vue?vue&type=template&id=84880c34&slot=default"
import script from "./ApplicationPermission.vue?vue&type=script&lang=js"
export * from "./ApplicationPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports